import { render, staticRenderFns } from "./DependentInformation.vue?vue&type=template&id=b8293410&scoped=true"
import script from "./DependentInformation.vue?vue&type=script&lang=js"
export * from "./DependentInformation.vue?vue&type=script&lang=js"
import style0 from "./DependentInformation.vue?vue&type=style&index=0&id=b8293410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8293410",
  null
  
)

export default component.exports